export default __webpack_public_path__ + "static/media/sbo-img.6b8148b2.png";